import { CommonFlags as c, DefaultColumns, EntityColumn, EntityColumnFlags, EntityDefinition, MicroMClient, ValuesObject } from "@mcurros2/microm";
import { ListasValoresItems } from "../../ListasValoresItems/ListasValoresItems";
import { DatosServiciosGestionViewColumnsOverrides } from "./DatosServiciosGestionViewColumnsOverrides";

const columns = () =>
(
    {
        c_visita_id: new EntityColumn<string>({ name: 'c_visita_id', type: 'char', length: 20, flags: c.PK, prompt: 'Visita Id' }),
        c_cliente_id: new EntityColumn<string>({ name: 'c_cliente_id', type: 'char', length: 20, flags: c.PK, prompt: 'Cliente Id' }),
        c_producto_id: new EntityColumn<string>({ name: 'c_producto_id', type: 'char', length: 20, flags: c.PK, prompt: 'Producto Id' }),
        c_servicio_id: new EntityColumn<string>({ name: 'c_servicio_id', type: 'char', length: 20, flags: c.PK, prompt: 'Servicio Id' }),
        c_paso_id: new EntityColumn<string>({ name: 'c_paso_id', type: 'char', length: 20, flags: c.PK, prompt: 'Paso Id' }),
        c_datos_servicio_id: new EntityColumn<string>({ name: 'c_datos_servicio_id', type: 'char', length: 20, flags: c.FK, prompt: 'Datos Servicio Id' }),
        c_datos_servicio_registro_id: new EntityColumn<string>({ name: 'c_datos_servicio_registro_id', type: 'char', length: 20, flags: c.FK, prompt: 'Datos Servicio Registro Id' }),
        c_datos_servicio_set_id: new EntityColumn<string>({ name: 'c_datos_servicio_set_id', type: 'char', length: 20, flags: c.PK, prompt: 'Datos Servicio Set Id' }),
        c_tienda_id: new EntityColumn<string>({ name: 'c_tienda_id', type: 'char', length: 20, flags: c.FK, prompt: 'Tienda Id' }),
        vc_producto: new EntityColumn<string>({ name: 'vc_producto', type: 'varchar', flags: EntityColumnFlags.None, prompt: 'Producto' }),
        vc_servicio: new EntityColumn<string>({ name: 'vc_servicio', type: 'varchar', flags: EntityColumnFlags.None, prompt: 'Servicio' }),
        bt_encabezado: new EntityColumn<boolean>({ name: 'bt_encabezado', type: 'bit', flags: EntityColumnFlags.None, prompt: 'Encabezado' }),
        vc_paso: new EntityColumn<string>({ name: 'vc_paso', type: 'varchar', flags: EntityColumnFlags.None, prompt: 'Paso' }),
        vc_paso_observaciones: new EntityColumn<string>({ name: 'vc_paso_observaciones', type: 'varchar', flags: EntityColumnFlags.None, prompt: 'Paso Observaciones' }),
        c_listavalores_id: new EntityColumn<string>({ name: 'c_listavalores_id', type: 'char', length: 20, flags: c.FK, prompt: 'Lista Valores' }),
        bt_unsolovalor: new EntityColumn<boolean>({ name: 'bt_unsolovalor', type: 'bit', flags: EntityColumnFlags.None, prompt: 'Un solo valor' }),
        c_tipoDatoServicios: new EntityColumn<string>({ name: 'c_tipoDatoServicios', type: 'char', length: 20, flags: c.FK, prompt: 'Tipo Dato Servicios' }),
        vc_valor_texto: new EntityColumn<string>({ name: 'vc_valor_texto', type: 'varchar', flags: c.Edit, prompt: 'Valor' }),
        n_valor_numerico: new EntityColumn<number>({ name: 'n_valor_numerico', type: 'decimal', length: 18, scale: 4, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Valor' }),
        vc_listavalores: new EntityColumn<string[]>({ name: 'vc_listavalores', type: 'varchar', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Valor', isArray: true }),
        vc_fileprocess: new EntityColumn<string[]>({ name: 'vc_fileprocess', type: 'varchar', flags: c.Edit, prompt: 'Fileprocess', isArray: true }),
        vc_tienda: new EntityColumn<string>({ name: 'vc_tienda', type: 'varchar', flags: EntityColumnFlags.None, prompt: 'Tienda' }),
        dt_fecha_hora_realizado: new EntityColumn<Date>({ name: 'dt_fecha_hora_realizado', type: 'datetime', flags: c.Edit, prompt: 'Fecha de inicio' }),
        ...DefaultColumns()
    }
)

const views = () =>
(
    {
        dags_brwStandard: { name: 'dags_brwStandard', keyMappings: { c_datos_servicio_id: 0 } },
        dags_brwServicios: {
            name: 'dags_brwServicios'
            , keyMappings: { c_visita_id: 7, c_cliente_id: 8, c_producto_id: 9, c_servicio_id: 10, c_paso_id: 11, c_datos_servicio_set_id: 13 }
            , gridColumnsOverrides: DatosServiciosGestionViewColumnsOverrides
        }
    }
)

const lookups = () =>
(
    {
        'ListaValores': {
            name: 'ListaValores',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new ListasValoresItems(client, parentKeys)
        }
    }
)

const procs = () =>
(
    {
        dags_GenerarDatosServiciosId: { name: 'dags_GenerarDatosServiciosId' }
    }
)

export class DatosServiciosGestionServiciosDef extends EntityDefinition {

    columns = columns();
    views = views();
    lookups = lookups();
    procs = procs();

    constructor() {
        super('DatosServiciosGestionServicios');
    }
}